import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NoticiasService {

  constructor(private readonly http: HttpClient) {
  }

  getAllNoticias(idEmpresa: string, dataFiltrada: any, reajuste: string, migracao: string, inputConteudo: string) {
    let queryParams = new HttpParams();

    if (inputConteudo) {
      queryParams = queryParams.append('conteudo', inputConteudo);
    }

    if (dataFiltrada) {
      queryParams = queryParams.append('dataFiltro', dataFiltrada);
    }

    if (reajuste) {
      queryParams = queryParams.append('buscaPeloTema', reajuste);
    }
    if (migracao) {
      queryParams = queryParams.append('buscaPeloTema', migracao);
    }

    return this.http.get(`/apiconnect/importation/news/summary/${idEmpresa}/companies`, {params: queryParams});
  }

  getNoticia(idNoticia: string) {
    const url = `/apiconnect/importation/news/${idNoticia}/news`;

    return this.http.get(url);
  }
}
